'use strict';
// videojsloader loads videojs with required dependencies and returns videojs object
define('hlsPlayer',['videojsLoader'], function (videojs) {
	return function (playerContainerID) {
		var streaming = false,
			playerContainer = document.getElementById(playerContainerID) || document.body,
			playerElement,
			player;

		function setMuted(muted) {
			if (player) {
				player.muted(muted);
			}
		}

		function handleEnd() {
			if (!streaming) {
				this.reject();
				return;
			}

			if (typeof this.callback === 'function') {
				this.callback();
			}

			// Dispose previous player if exists
			dispose();
		}

		function dispose() {
			if (player) {
				player.dispose();
				player = undefined;
			}

			if (playerElement) {
				playerElement.remove();
				playerElement = undefined;
			}

			streaming = false;
		}

		return {
			init: function () {
				return new Promise(function (resolve) {
					// Dispose previous player if exists
					dispose();

					// Setup video element
					playerElement = document.createElement('video');
					playerContainer.appendChild(playerElement);

					// Init VideoJS
					player = videojs(playerElement, {
						controls: false,
						manualCleanup: false,
						preload: true,
						children: ['mediaLoader'],
						html5: {
							vhs: {
								overrideNative: true
							}
						}
					}, function () {
						this.on('playing', function () {
							streaming = true;
							this.resolve();
						});
						this.on('ended', handleEnd);
						this.on('error', handleEnd);
					});

					resolve();
				});
			},
			setMuted: setMuted,
			play: function (url, muted, callback) {
				return new Promise(function (resolve, reject) {
					player.resolve = resolve;
					player.reject = reject;
					player.callback = callback;

					setMuted(muted);
					player.src({
						src: url,
						type: 'application/x-mpegURL'
					});

					player.play();
				});
			},
			clear: dispose
		};
	};
});

